import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { useTranslation } from 'react-i18next';
import { ErrorStatusEnum } from '@app/common';
import { useRootStore } from '../../../providers/root-store-provider';
import { withAuth } from '../../../models/functions/with-auth';
import { Layout } from '../../../blocks/app/layout/layout';
import SharedPortfolio from '../../../blocks/app/shared-portfolio/shared-portfolio';
import { routes } from '../../../config/routes';

const ShareSlug: React.FC = () => {
    const { t } = useTranslation();
    const router = useRouter();
    const { statisticStore, portfolioStore, alertStore } = useRootStore();

    const { shareSlug } = router.query;

    useEffect(() => {
        const handleSharedPortfolioLoad = async () => {
            try {
                await portfolioStore.fetchSharedPortfolio(shareSlug as string);
            } catch (e) {
                await router.push(routes.app.index);
                alertStore.setErrorMessageByStatus(ErrorStatusEnum.SharedPortfolioDoesNotExist);
            }
        };

        handleSharedPortfolioLoad();

        return () => {
            portfolioStore.clearSharedPortfolio();
        };
    }, []);

    useEffect(() => {
        if (portfolioStore.sharedPortfolio) {
            statisticStore.fetchIndexData();
            statisticStore.investownAssetMonthlyStatusStore.fetchMonthlyStatus();
            statisticStore.investownAssetMonthlyStatusStore.fetchMonthlyStatusPaginated();
            statisticStore.profitStore.fetchProfitCharts();
        }
    }, [portfolioStore.sharedPortfolio?.id]);

    if (portfolioStore.sharedPortfolio === null) {
        return <></>;
    }

    return (
        <Layout>
            <Head>
                <title>
                    {t('pages.app.sharedPortfolio.meta.title')}
                    {portfolioStore.sharedPortfolio.name}
                    {t('meta.title.suffix')}
                </title>
            </Head>
            <SharedPortfolio
                name={portfolioStore.sharedPortfolio.name}
                numberOfAssets={portfolioStore.sharedPortfolio.numberOfAssets}
            />
        </Layout>
    );
};

export default withAuth(ShareSlug);
